import { assert_is_safe_number } from '@shared/asserts/utils_asserts';
import { DTO__number_range } from '@shared/dto/generation/settings/DTO__number_range';

declare global {
  interface Number {
    format_with_spaces(): string;

    to_fixed(precision: number): number;

    to_fixed_floor(precision: number): number;

    snap_to(step: number): number;

    snap_to_8(): number;

    snap_to_8_and_clamp(min: number, max: number): number;
  }
}

Number.prototype.format_with_spaces = function (this: number): string {
  return this.toLocaleString('en-US').replace(/,/g, ' ');
};

Number.prototype.to_fixed = function (this: number, precision: number): number {
  const step = Math.pow(10, precision);

  let out = Math.round(this * step) / step;

  let out_string = out.toFixed(precision);

  out = parseFloat(out_string);

  return out;
};

Number.prototype.to_fixed_floor = function (this: number, precision: number): number {
  const step = Math.pow(10, precision);

  let out = Math.floor(this * step) / step;

  let out_string = out.toFixed(precision);

  out = parseFloat(out_string);

  return out;
};

Number.prototype.snap_to = function (this: number, step: number): number {
  assert_is_safe_number(step);

  return Math.round(this / step) * step;
};

Number.prototype.snap_to_8 = function (this: number): number {
  return this.snap_to(8);
};

Number.prototype.snap_to_8_and_clamp = function (this: number, min: number, max: number): number {
  let out = this.snap_to_8();

  let range = new DTO__number_range(min, max);

  out = range.clamp(out);

  return out;
};

export {}; // This ensures TypeScript treats it as a module
